import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { GS1AccordionModule, GS1ButtonModule, GS1FormModule, GS1LayoutModule, GS1LoaderModule, GS1TablesModule } from '@gs1france/gs1-components-library';
import { AccountGLNComponent } from './components/account-gln/account-gln.component';
import { CreationGLNComponent } from './components/creation-gln/creation-gln.component';
import { HubComponent } from './components/hub/hub.component';
import { ImportExportComponent } from './components/import-export/import-export.component';
import { HubRoutingModule } from './hub-routing.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { ShowGLNComponent } from './components/show-gln/show-gln.component';
import { CoreModule } from '../core/core.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
 
/**
 * The main module for the Account part of the app.
 * @module HubModule
 */
@NgModule({
  declarations: [
    HubComponent, AccountGLNComponent, CreationGLNComponent, ImportExportComponent, ShowGLNComponent
  ],
  imports: [
    CoreModule, CommonModule, HubRoutingModule, ReactiveFormsModule, NgSelectModule,
    GS1ButtonModule, GS1TablesModule, GS1LoaderModule, GS1FormModule,
    MatProgressBarModule, GS1LayoutModule, MatTooltipModule, GS1AccordionModule, MatProgressSpinnerModule, MatCardModule
    
]
})
export class HubModule { }
